import {createRoot} from 'react-dom/client'
// Apps
import {AuthProvider} from '@context/Auth'
import {BrandingProvider} from '@context/Branding'
import {MetronicI18nProvider} from '_metronic/i18n/Metronici18n'
import {ThemeModeProvider} from '_metronic/partials/layout/theme-mode/ThemeModeProvider'
import 'assets/sass/plugins.scss'
import 'assets/sass/style.react.scss'
import 'assets/sass/style.scss'
// Imported HERE, never from the lazily-loaded DashboardWrapper: a stylesheet imported from a
// lazily-loaded route module is extracted into that route's own CSS chunk, which compiles and is
// served while the rules still fail to reach the paint.
import 'pages/dashboard/dashboard.scss'
// Same reason: the saved-document dialog is fired from six lazily-loaded procurement forms.
import '@services/utils/doc-alert.scss'
import {ToastContainer} from 'react-toastify'
import {AppRoutes} from './routing/AppRoutes'

const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <MetronicI18nProvider>
      <ThemeModeProvider>
        <AuthProvider>
          <BrandingProvider>
            <AppRoutes />
          </BrandingProvider>
        </AuthProvider>
      </ThemeModeProvider>
      <ToastContainer
        position='top-right'
        autoClose={4000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme='colored'
      />
    </MetronicI18nProvider>
  )
}
